module.exports = __webpack_public_path__ + "img/banner-step3.3884a27a.png";